import {
  CREATE_EVENT,
  CREATE_EVENT_FAILED,
  CREATE_EVENT_SUCCESS,
  GET_EVENTS,
  GET_EVENTS_SUCCESS,
  ON_CHANGE_TAB_EVENT,
  SORT_EVENTS,
  GET_EVENT_BY_ID,
  GET_EVENT_SUCCESS,
  GET_PAST_EVENTS,
  GET_PAST_EVENTS_SUCCESS,
  GET_PAST_EVENTS_FAILED,
  CANCEL_EVENT,
  CANCEL_EVENT_SUCCESS,
  CANCEL_EVENT_FAILED,
  GET_FILTERED_EVENTS,
  GET_FILTERED_EVENTS_SUCCESS,
  GET_FILTERED_EVENTS_FAILED,
  RESET_FILTERED_EVENTS,
  UPDATE_EVENT,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAILED,
  RESET_UPDATE_EVENT_FORM,
  SET_EVENT,
  SEND_NOTIFICATION_SMS_TO_VENDORS,
  SEND_NOTIFICATION_SMS_TO_VENDORS_SUCCESS,
  SEND_NOTIFICATION_SMS_TO_VENDORS_FAILED,
  ON_DISPLAY_MODAL_SMS,
  GET_EVENTS_FAILED,
  DISABLE_EVENT,
  SET_MANAGE_EVENT_TAB,
  GET_DIGITAL_MARKETING,
  GET_DIGITAL_MARKETING_SUCCESS,
  GET_DIGITAL_MARKETING_FAILED,
  CHANGE_LOADING,
} from './constants';
import { formatDate } from '../../utils';

const createEvent = (eventData) => ({
  type: CREATE_EVENT,
  payload: { event: eventData },
});

const createEventSuccess = (eventData) => ({
  type: CREATE_EVENT_SUCCESS,
  payload: { event: eventData },
});

const createEventFailed = (error) => ({
  type: CREATE_EVENT_FAILED,
  payload: { error },
});

const updateEvent = (eventData, navigate) => ({
  type: UPDATE_EVENT,
  payload: { event: eventData, navigate },
});

const updateEventSuccess = (eventData) => ({
  type: UPDATE_EVENT_SUCCESS,
  payload: { event: eventData },
});

const updateEventFailed = (error) => ({
  type: UPDATE_EVENT_FAILED,
  payload: { error },
});

const getPastEvents = (userId, userRole) => ({
  type: GET_PAST_EVENTS,
  payload: { userId, userRole },
});

const getEventsByVenue = (venueId) => ({
  type: GET_EVENTS,
  payload: { venueId },
});

const getEventsByVenueSuccess = (eventList) => ({
  type: GET_EVENTS_SUCCESS,
  payload: { eventList },
});

const getEventsByVenueFailed = (error) => ({
  type: GET_EVENTS_SUCCESS,
  payload: { error },
});

const getEventById = (eventId, role = null) => ({
  type: GET_EVENT_BY_ID,
  payload: { eventId, role },
});

const getDigitalMarketing = (eventId) => ({
  type: GET_DIGITAL_MARKETING,
  payload: { eventId },
});

const getEventSuccess = (event) => ({
  type: GET_EVENT_SUCCESS,
  payload: { event },
});

const getDigitalMarketingSuccess = (urlData) => ({
  type: GET_DIGITAL_MARKETING_SUCCESS,
  payload: { urlData },
});

const getEventByIdFailed = (error) => ({
  type: GET_EVENTS_FAILED,
  payload: { error },
});

const getDigitalMarketingFailed = (error) => ({
  type: GET_DIGITAL_MARKETING_FAILED,
  payload: { error },
});

const getPastEventsSuccess = (pastEvents) => ({
  type: GET_PAST_EVENTS_SUCCESS,
  payload: { pastEvents },
});

const getPastEventsFailed = (error) => ({
  type: GET_PAST_EVENTS_FAILED,
  payload: { error },
});

const onSortEvents = (sortBy) => ({
  type: SORT_EVENTS,
  payload: { sortBy },
});

const onChangeTabEvent = (tab) => ({
  type: ON_CHANGE_TAB_EVENT,
  payload: { tab },
});

const onChangeLoading = (newStatus) => ({
  type: CHANGE_LOADING,
  payload: { newStatus },
});

const onCancelEvent = (eventId) => ({
  type: CANCEL_EVENT,
  payload: { eventId },
});

const disableEvent = (eventId) => ({
  type: DISABLE_EVENT,
  payload: { eventId },
});

const onCancelEventSuccess = (eventId) => ({
  type: CANCEL_EVENT_SUCCESS,
  payload: { eventId },
});

const onCancelEventFailed = (error) => ({
  type: CANCEL_EVENT_FAILED,
  payload: { error },
});

const getFilteredEvents = (filter, onDataFetched) => {
  const currentDate = formatDate(new Date(), 'YYYY-MM-DD');

  const updatedFilter = {
    ...filter,
    start_date: `${currentDate}T00:00:00Z`, // Set the start date to today's date which is making sure that no past events show when searching in the search bar
  };

  return {
    type: GET_FILTERED_EVENTS,
    payload: { filter: updatedFilter, onDataFetched },
  };
};

const getFilteredEventsSuccess = (filteredEvents) => ({
  type: GET_FILTERED_EVENTS_SUCCESS,
  payload: { filteredEvents },
});

const getFilteredEventsFailed = (error) => ({
  type: GET_FILTERED_EVENTS_FAILED,
  payload: { error },
});

const resetFilteredEvents = () => ({
  type: RESET_FILTERED_EVENTS,
});

const resetUpdateEventForm = () => ({
  type: RESET_UPDATE_EVENT_FORM,
});

const onChangeEventManagerTab = (tab) => ({
  type: SET_MANAGE_EVENT_TAB,
  payload: { tab },
});

const setEvent = (event) => ({
  type: SET_EVENT,
  payload: { event },
});

const sendNotificationSMSToVendors = (message, eventId) => ({
  type: SEND_NOTIFICATION_SMS_TO_VENDORS,
  payload: { message, eventId },
});

const sendNotificationSMSToVendorsSuccess = () => ({
  type: SEND_NOTIFICATION_SMS_TO_VENDORS_SUCCESS,
});

const sendNotificationSMSToVendorsFailed = (error) => ({
  type: SEND_NOTIFICATION_SMS_TO_VENDORS_FAILED,
  payload: { error },
});

const onDisplayModalSMS = (status) => ({
  type: ON_DISPLAY_MODAL_SMS,
  payload: { status },
});

export {
  createEvent,
  createEventSuccess,
  createEventFailed,
  getEventsByVenue,
  getEventSuccess,
  getEventsByVenueSuccess,
  getEventsByVenueFailed,
  getPastEvents,
  getPastEventsSuccess,
  getPastEventsFailed,
  onChangeTabEvent,
  onSortEvents,
  getEventById,
  getEventByIdFailed,
  onCancelEvent,
  onCancelEventSuccess,
  onCancelEventFailed,
  getFilteredEvents,
  getFilteredEventsSuccess,
  getFilteredEventsFailed,
  resetFilteredEvents,
  updateEvent,
  updateEventSuccess,
  updateEventFailed,
  resetUpdateEventForm,
  setEvent,
  sendNotificationSMSToVendors,
  sendNotificationSMSToVendorsSuccess,
  sendNotificationSMSToVendorsFailed,
  getDigitalMarketing,
  getDigitalMarketingSuccess,
  getDigitalMarketingFailed,
  onDisplayModalSMS,
  disableEvent,
  onChangeEventManagerTab,
  onChangeLoading,
};
